import { IStyle } from '@fluentui/react';

export interface IProjectsStyles {
  root?: IStyle;
}

export interface IProjectsClassNames {
  root: string;
}

export const projectsStylesDefault = (): Partial<IProjectsStyles> => ({
  root: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
});
